module.exports = __webpack_public_path__ + "static/BannerTalent-80bd2e0edfab06c89337ef6ca4c9ea3f.png";